import * as React from "react"

const Google = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M10.294 5.284C9.672 4.689 8.88 4.386 8 4.386c-1.563 0-2.885 1.056-3.357 2.474-.12.36-.188.745-.188 1.14 0 .395.068.78.188 1.14.472 1.418 1.794 2.473 3.357 2.473.807 0 1.495-.212 2.032-.572a2.76 2.76 0 0 0 1.197-1.811H8V6.909h5.65c.072.393.11.802.11 1.227 0 1.828-.655 3.366-1.79 4.41C10.979 13.463 9.62 14 8 14a5.998 5.998 0 0 1-5.362-8.694A5.998 5.998 0 0 1 8 2c1.617 0 2.976.595 4.014 1.563l-1.72 1.72Z" />
  </svg>
)

export default Google
